import { Component, OnInit, inject } from "@angular/core";

import {
  ROUTE_ANIMATIONS_ELEMENTS,
  routeAnimations,
  selectorAuth
} from "@app/core";
import { select, Store } from "@ngrx/store";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  animations: [routeAnimations]
})
export class HomeComponent implements OnInit {
  private store = inject<Store<any>>(Store);

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  isAuthenticated: boolean;
  isAdmin: boolean;
  private unsubscribe$: Subject<void> = new Subject<void>();

  ngOnInit() {
    this.subscribeToIsAuthenticated();
  }

  private subscribeToIsAuthenticated() {
    this.store
      .pipe(select(selectorAuth))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((auth) => {
        this.isAuthenticated = auth.isAuthenticated;
        this.isAdmin = auth.isAdmin;
      });
  }
}
